module.exports = __webpack_public_path__ + "img/fra.b1156355.svg";